/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { PBL_FORM_SET_ADDRESS } from '@engine/actions/action-types';
export var setAddress = function setAddress(data) {
  return {
    type: PBL_FORM_SET_ADDRESS,
    data: data
  };
};
export function requestConsumerAddress(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return function (dispatch) {
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(setAddress(json));
    })["catch"](function () {
      return dispatch(setAddress({}));
    });
  };
}